<template>
  <div>
    <label class="grey--text text--darken-4 text-body-2 font-weight-medium">
      {{ title }}
    </label>

    <VueEditor
      v-on="$listeners"
      v-bind="$attrs"
      resize
      class="text-body-2 font-weight-regular mt-1 textarea-editor"
      :class="{ resize: !noResize }"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    noResize: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea-editor::v-deep {
  .ql-toolbar {
    border-radius: 8px 8px 0 0;
  }

  .ql-container {
    border-radius: 0 0 8px 8px;
  }

  .ql-editor {
    min-height: auto;
    height: 140px;
  }

  &.resize {
    .ql-editor {
      min-height: 140px;
      height: 140px;
      max-height: calc(100dvh - 340px);
      resize: vertical;
    }
  }
}
</style>
